import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getAlertDetails = (state: StateScheme) => {
    return state.globalAlertModal.alertDetails
}
